import React, { useMemo } from 'react';
import webApp from '@happylife-a/web-app';
import webCore from '@happylife-a/web-core';
import { IconButton, Icon, Flex } from '@chakra-ui/react';

export default function FavoriteButtonV1({ productDetailId, onToggle, isOutOfStock }) {
  const { isFavorite, favorites } = webCore.contexts.useFavorites();

  const isFavoriteItem = useMemo(
    () => isFavorite(productDetailId),
    [isFavorite, productDetailId, favorites?.ids]
  );

  const onClick = (e) => {
    e.preventDefault();
    if (onToggle) {
      onToggle();
    }
  };

  return (
    <Flex
      ml={{ base: 'auto', md: 0 }}
      borderRadius="50%"
      borderWidth={0}
      borderStyle="solid"
      borderColor="primary.500"
      justifyContent="center"
      alignItems="center"
    >
      <IconButton
        variant="transparent"
        height="auto"
        justifyContent="flex-end"
        minWidth="unset"
        isDisabled={isOutOfStock}
        icon={
          <Icon
            as={webApp.theme.icons.FavoriteIcon}
            fill={isFavoriteItem ? 'primary.500' : 'none'}
            stroke={isFavoriteItem ? 'none' : 'primary.500'}
            h={5}
            w={'24px'}
          />
        }
        onClick={onClick}
      />
    </Flex>
  );
}
